<template>
  <div class="sidebar">
    <div class="mb2">
      <router-link class="link pa2 pl0 flex items-center w-100" :to="{name: 'home'}">
        <span class="icon mr1 text--theme-highlight flex items-center">
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 8"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g
                transform="translate(8.000000, 4.000000) rotate(-180.000000) translate(-8.000000, -4.000000) translate(-4.000000, -8.000000)"
              >
                <polygon points="0 0 24 0 24 24 0 24"></polygon>
                <polygon
                  class="polygon"
                  fill="#000000"
                  points="16.01 11 4 11 4 13 16.01 13 16.01 16 20 12 16.01 8"
                ></polygon>
              </g>
            </g>
          </svg>
        </span>
        <span class="text--theme-highlight">{{$t('sidebarTopLink')}}</span>
      </router-link>
    </div>
    <div class="sidebar__links ba b--gray pv3">
      <ul class="list pa0 ma0">
        <li @click="trackPageClick(`sidebar_using_sitename`)">
          <router-link
            class="link no-underline"
            :to="{name: `using-site`}"
          >{{getTitle('using-site')}}</router-link>
        </li>
        <li @click="trackPageClick(`sidebar_billing_support`)">
          <router-link
            class="link no-underline"
            :to="{name: 'billing-support'}"
          >{{getTitle('billing-support')}}</router-link>
        </li>
        <li @click="trackPageClick(`sidebar_account_support`)">
          <router-link
            class="link no-underline"
            :to="{name: 'account-support'}"
          >{{getTitle('account-support')}}</router-link>
        </li>
        <li @click="trackPageClick(`sidebar_technical_support`)">
          <router-link
            class="link no-underline"
            :to="{name: 'technical-support'}"
          >{{getTitle('technical-support')}}</router-link>
        </li>
        <li @click="trackPageClick(`sidebar_partners_authors`)">
          <router-link
            class="link no-underline"
            :to="{name: 'partners-authors'}"
          >{{getTitle('partners-authors')}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getCategoryPageName, trackPageClick } from '@/utils/common';

export default {
  computed: {
    siteName() {
      return this.$store.state.siteDetails.site_name;
    },
    categories() {
      return this.$store.state.categories;
    }
  },
  methods: {
    getCategoryName(categoryId) {
      return getCategoryPageName(categoryId, this.$store.state.flowObject.pages);
    },
    trackPageClick(clickName) {
      return trackPageClick(clickName);
    },
    getTitle(pageName) {
      return this.$store.state.categories[this.$store.state.flowObject.pages[pageName].meta.categoryId].title;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

span.text--theme-highlight:nth-child(2) {
  font-weight: 400;
}
.sidebar {
  .icon .polygon {
    fill: $theme-highlight;
  }
}
.sidebar__links {
  ul li {
    margin-bottom: 1rem;
  }
  .link {
    color: #999;
    display: block;
    padding: 0.2em 1.3em;
    border-left: 3px solid transparent;

    &:hover {
      // &.router-link-exact-active {
      color: $theme-highlight;
      border-left: 3px solid #3bb4ef;
    }
  }
}

@media (min-width: 641px) and (max-width: 832px) {
  .link {
    padding-right: 0;
  }
}
</style>
